let config = (data = {}) => {
  return {
    system: {
      // 系统
    },
    website: {
      // 网站建设
    },
    google: {
      // 谷歌推广
    },
    SMConstruction: {
      // 社媒建设
    },
    SMOperation: {
      // 社媒运营
    },
    video: {
      // 视频拍摄
    },
    facebook: {
      // FB推广
    },
  }
}
export default config
